<template>
	<div>
		<a-table :pagination="pagination" :rowKey="rowKey" :rowSelection="rowSelection" @change="handleTableChange" :columns="columns" :dataSource="dataSource" :loading="loading" :scroll="scroll" :bordered="border"
		:rowClassName="rowClassName">
			<template slot="customTitle">
				<slot name="customTitle"></slot>
			</template>
			<template :slot="footerName">
				<slot name="customFooter" :extraData="extraData"></slot>
			</template>
			<template slot="format1" slot-scope="text, record">
				<slot name="format1" :record="record" :text="text"></slot>
			</template>
			<template slot="format2" slot-scope="text, record">
				<slot name="format2" :record="record" :text="text"></slot>
			</template>
			<template slot="format3" slot-scope="text, record">
				<slot name="format3" :record="record" :text="text"></slot>
			</template>
			<template slot="format4" slot-scope="text, record">
				<slot name="format4" :record="record" :text="text"></slot>
			</template>
			<template slot="format5" slot-scope="text, record">
				<slot name="format5" :record="record" :text="text"></slot>
			</template>
			<template slot="format6" slot-scope="text, record">
				<slot name="format6" :record="record" :text="text"></slot>
			</template>
			<template slot="format7" slot-scope="text, record">
				<slot name="format7" :record="record" :text="text"></slot>
			</template>
			<template slot="format8" slot-scope="text, record">
				<slot name="format8" :record="record" :text="text"></slot>
			</template>
			<template slot="format9" slot-scope="text, record">
				<slot name="format9" :record="record" :text="text"></slot>
			</template>
			<template slot="format10" slot-scope="text, record">
				<slot name="format10" :record="record" :text="text"></slot>
			</template>
			<template slot="format11" slot-scope="text, record">
				<slot name="format11" :record="record" :text="text"></slot>
			</template>
			<template slot="omitStr" slot-scope="text, record">
				<a-tooltip placement="topLeft" v-if="text" :title="text">{{ text.replace(/[\r\n]/g,"").replace(/(.{10})(.*)/, '$1...') }}</a-tooltip>
			</template>
			<template slot="ellipsis" slot-scope="text, record">
				<a-tooltip placement="topLeft" :title="text">{{ text }}</a-tooltip>
			</template>
			<template slot="formatDate" slot-scope="text, record">
				<span v-if="text">{{ text.substr(0,10) }}</span>
			</template>
			<template slot="formatMoney" slot-scope="text, record">
				<span v-if="text || text == 0">{{text | formatMoney}}</span>
			</template>
			<template slot="action2" slot-scope="text, record">
				<a-dropdown :trigger="['click']" placement="bottomCenter" overlayClassName="menu_box">
			        <a-icon class="ant-dropdown-link" type="ellipsis" style="cursor: pointer;" />
			        <a-menu slot="overlay">
						<slot name="action2" :record="record"></slot>
			        </a-menu>
			    </a-dropdown>
			</template>
			<template slot="action" slot-scope="text, record">
				<a-dropdown :trigger="['click']" placement="bottomCenter" overlayClassName="menu_box">
                    <a-icon class="ant-dropdown-link" type="ellipsis" style="cursor: pointer;" />
                    <a-menu slot="overlay">
						<slot :record="record"></slot>
                    </a-menu>
                </a-dropdown>
			</template>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'CustomPage',
		props: {
			columns: {
				type: Array
			},
			url: {
				type: String,
			},
			rowKey: {
				type: String,
				default: null
			},
			scroll: {
				type: Object,
				default: () => {
					x: 0
				}
			},
			border:{
				type:Boolean,
				default: false
			},
			staticData:{
				type:Array,
				default: () => []
			},
			isRowSelection: {
				type: Boolean,
				default: false
			},
			selectSonData:{
				type: Array,
				default:() => []
			},
			rowClassCondition:{
				type: Array,
				default:() => []
			},
			showFooter: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			rowSelection: {
				get: function(){
					if(this.isRowSelection){
						return {selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange}
					}
					return null;
				},
				set: function(){

				}
			},
			footerName: {
				get: function(){
					if(this.showFooter){
						return "footer";
					}else{
						return "noFooter"
					}
				}
			}
		},
		data() {
			return {
				loading:false,
				dataSource: this.staticData,
				pagination:{
					current:1,
					defaultCurrent:1,
					defaultPageSize:10,
					pageSize:10,
					pageSizeOptions:['10', '20', '30', '50','100'],
					showQuickJumper:true,
					showSizeChanger:true,
					showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
					total:0
				},
				params:{},
				selectedRowKeys: [],
				extraData: {}
			}
		},
		methods: {
			setPagination(pagination){
				this.pagination = pagination
			},
			rowClassName(record, index){
				let className;
				for(let item of this.selectSonData){
					if(item === record.key){
						className = 'choose'
					}
				}
				// 设置行样式显示、从组件中传入是哪个字段、条件值、行classname
				if (this.rowClassCondition && this.rowClassCondition.length > 0){
					for(let item of this.rowClassCondition){
						if(item.hasOwnProperty('field')){
							let field = item.field;
							if(record[field] == item.conditionVal){
								className = item.className;
							}
						}
					}
				}

				return className;
			},
		    handleTableChange (pagination, filters, sorter) {
		    	this.resetSelectRowKeys();
		      	this.params.pageSize = pagination.pageSize;
		      	this.params.pageNum = pagination.current;
		      	if(sorter.field){
		      		this.params.sortField = sorter.field;
		      	}
		      	if(sorter.order){
		      		this.params.sortOrder = sorter.order;
		      	}
		      	this.fetch();
		    },
		    handleList({ ...params}){
		    	if(!params.pageNum && !this.params.pageNum){
		    		this.params.pageNum = this.pagination.defaultCurrent;
		    	}
		    	if(!params.pageSize && !this.params.pageSize){
		    		this.params.pageSize = this.pagination.defaultPageSize;
		    	}
		    	if(!params.sortField && !this.params.sortField){
		    		this.params.sortField = "id";
		    	}
		    	if(!params.sortOrder && !this.params.sortOrder){
		    		this.params.sortOrder = "descend";
		    	}
		    	let newParams = {};
		    	for(let i in params){
		    		if(params[i] === undefined){
		    			newParams[i] = null;
		    		}else{
		    			newParams[i] = params[i];
		    		}
		    	}
		    	for(let ele of ['pageNum','pageSize','sortField','sortOrder']){
		    		if(!newParams[ele]){
		    			delete newParams[ele]
		    		}
		    	}
		    	this.params = {
		    		...this.params,
		    		...newParams
		    	}
		    	this.fetch();
		    },
		    fetch () {
		      	this.loading = true;
		      	this.$get(this.url, this.params).then(res => {
					this.pagination.total = res.data.total;
					this.pagination.pageSize = res.data.size;
					this.dataSource = res.data.rows;
					if(res.data.extraData){
						this.extraData = res.data.extraData;
					}else{
						this.extraData = {};
					}
					if(res.data.rows && res.data.rows.length > 0){
						this.pagination.current = this.params.pageNum;
					}else{
						this.pagination.current = this.params.pageNum - 1;
					}
			        this.loading = false;
					this.selectedRowKeys = [];
					this.$emit('callbackExtData',this.extraData);
				})
		    },
		    onSelectChange(selectedRowKeys, selectedRows){
		    	this.selectedRowKeys = selectedRowKeys
				this.$emit('onSelectChange',this.selectedRowKeys,selectedRows);
		    },
		    getSelectedRows(){
				let data = [];
		    	for (let key of this.selectedRowKeys) {
					let temp = this.rowKey ? this.dataSource.find(o => o[this.rowKey] == key) : this.dataSource[key]
					if(temp){
						data.push(temp)
					}
	          	}
		    	return data;
		    },
		    resetSelectRowKeys(){
		    	this.selectedRowKeys = [];
		    }
		}
	}
</script>

<style type="text/css" lang="less" scoped>
	/deep/.ant-btn:active, .ant-btn.active{
        border-color: transparent !important;
        background-color: transparent !important;
    }
    /deep/.ant-btn{
        border-color: transparent !important;
        background-color: transparent !important;
	}
	.menu_box ul{
		text-align: center !important;
	}
	/deep/.choose{
		background-color: #EEEEEE;
	}
	/deep/.graycol{
		color: #acacac;
		font-weight: 400;
	}
	/deep/.redcol{
		color: #FF0000 ;
		font-weight: 400;
	}
	/deep/.lightgraybg{
		background-color: lightgray;
		font-weight: 400;
	}
</style>



// WEBPACK FOOTER //
// src/views/common/CustomPage.vue